import { defineMessages } from 'react-intl';

export default defineMessages({
  backLabel: {
    id: 'Pdp.attributeModal.backLabel',
    defaultMessage: 'Close',
  },
});
